// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___yt23","fromWhomItem":"styles_fromWhomItem__CjWJ6","fromWhomActive":"styles_fromWhomActive__KckFF"};
module.exports.__checksum = "841ddc799e92"
